<template lang="pug">
    LineChart(
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
    )
</template>

<script>
import { Line } from 'vue-chartjs/legacy';

import 'chartjs-adapter-date-fns';
import { ru } from 'date-fns/locale';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  TimeScale,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  TimeScale,
);

export default {
  name: 'ChartTimeLine',
  components: { LineChart: Line },
  props: {
    data: Array,
  },
  computed: {
    chartId() { return this._id; }, // eslint-disable-line no-underscore-dangle
    testDataset() {
      const set = [];

      const date = new Date();

      for (let i = 0; i < 200; i += 1) {
        date.setDate(date.getDate() + 1);
        set.push({
          x: date.toISOString(),
          y: (i * 10 + 500) / 1024,
        });
      }

      return set;
    },
    maxValue() {
      return Math.max(...this.data.map(d => d.value));
    },
    dataTransform() {
      if (this.maxValue < 1024 * 1024) {
        return { unit: 'КБ', divider: 1024 };
      }

      if (this.maxValue < 1024 * 1024 * 1024) {
        return { unit: 'МБ', divider: 1024 * 1024 };
      }

      return { unit: 'ГБ', divider: 1024 * 1024 * 1024 };
    },
    divider() { return this.dataTransform.divider; },
    unit() { return this.dataTransform.unit; },
    dataset() {
      return this.data.map(s => ({
        x: s.createdAt,
        y: Math.round((s.value * 1000) / this.divider) / 1000,
      }));
    },
    chartData() {
      return {
        datasets: [
          {
            borderColor: '#203D5B',
            data: this.dataset,
            // cubicInterpolationMode: 'monotone',
            // tension: 0.4,
            pointStyle: 'circle',
            pointRadius: 1,
            pointHoverRadius: 8,
          },
        ],
      };
    },
    chartOptions() {
      const time = this.data.length > 30
        ? {
          unit: 'month',
          displayFormats: {
            month: 'LLL YYY',
          },
          tooltipFormat: 'PPP',
        }
        : {
          unit: 'day',
          displayFormats: {
            day: 'dd MMM',
          },
          tooltipFormat: 'PPP',
        };

      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: (this.maxValue * 1.2) / this.divider,
            title: {
              display: true,
              text: `Объем файлов проекта, ${this.unit}`,
            },
          },
          x: {
            type: 'time',
            time,
            adapters: {
              date: {
                locale: ru,
              },
            },
          },
        },
        plugins: {
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: this.externalTooltipHandler,
          },
        },
      };
    },
  },
  methods: {
    externalTooltipHandler(context) {
      // Tooltip Element
      const { chart, tooltip } = context;
      const tooltipEl = this.getOrCreateTooltip(chart);

      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }

      const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
      tooltipEl.style.padding = '10px';
      tooltipEl.innerText = '';

      const date = tooltip.title?.[0] ?? '';
      const value = tooltip.body?.[0].lines;

      const valueNode = document.createElement('div');
      valueNode.style.color = '#FFFFFF';
      valueNode.style.fontSize = '14px';
      valueNode.style.lineHeight = '17px';
      valueNode.style.textAlign = 'center';
      valueNode.innerText = `${value} ${this.unit}`;

      const dateNode = document.createElement('div');
      dateNode.style.color = '#F8F9FC';
      dateNode.style.fontSize = '10px';
      dateNode.style.lineHeight = '12px';
      dateNode.style.textAlign = 'center';
      dateNode.innerText = date;

      tooltipEl.appendChild(valueNode);
      tooltipEl.appendChild(dateNode);
      tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
      tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
      tooltipEl.style.opacity = 1;
    },
    getOrCreateTooltip(chart) {
      let tooltipEl = chart.canvas.parentNode.querySelector('div');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 10%)';
        tooltipEl.style.transition = 'all .1s ease';

        chart.canvas.parentNode.appendChild(tooltipEl);
      }

      return tooltipEl;
    },
  },
};

</script>

<style scoped>

</style>
